import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {
    VisitorCalendarActionCommand, VisitorSettingsCommand, VisitorStyleCommand, VisitorTripCommand, VisitorTripIdCommand,
} from '../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../commands/visitor/all.frontend.settings.command';
import {TravelMode} from "../common/services/google.maps.service";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";

@Injectable()
export class VisitorCalendarStore {
    public actionCommand = new BehaviorSubject(new VisitorCalendarActionCommand());
}

@Injectable()
export class VisitorStyleStore {
    public styleCommand = new BehaviorSubject(new VisitorStyleCommand());
}

@Injectable()
export class VisitorSettingsStore {
    public settingsCommand = new BehaviorSubject(new VisitorSettingsCommand());
}

@Injectable()
export class AllFrontendSettingsStore {
    public allFrontendSettingsCommand = new BehaviorSubject(new AllFrontendSettingsCommand());
}

@Injectable()
export class VisitorTripStore {
    public tripCommand = new BehaviorSubject(new VisitorTripCommand());
}

@Injectable()
export class VisitorTripIdStore {
    public tripIdCommand = new BehaviorSubject(new VisitorTripIdCommand());
}

@Injectable()
export class VisitorTripNotifyAddOrRemoveItemStore {
    public notifyCommand = new BehaviorSubject(null);
}

@Injectable()
export class TravelModeStore {
    public modeCommand = new BehaviorSubject(TravelMode.DRIVING);
}

export class VisitorDataCache {
    private static _places = null;
    private static _events = null;
    private static _tours = null;
    private static _placeCategories = null;
    private static _logo = '';
    private static _customDefaultPlaceCategoryMatMenus: any[] = [];

    public static get places() {
        return this._places;
    }

    public static set places(places) {
        this._places = places;
    }

    public static get events() {
        return this._events;
    }

    public static get logo() {
        return this._logo;
    }

    public static set events(events) {
        this._events = events;
    }

    public static get tours() {
        return this._tours;
    }

    public static set tours(tours) {
        this._tours = tours;
    }

    public static get placeCategories() {
        return this._placeCategories;
    }

    public static set placeCategories(placeCategories) {
        this._placeCategories = placeCategories;
    }

    public static set logo(logo) {
        this._logo = logo;
    }

    public static addCustomDefaultPlaceCategoryMatMenus(customDefaultPlaceCategoryMatMenu: MatMenuTrigger, level: number) {
        if (this._customDefaultPlaceCategoryMatMenus.indexOf(customDefaultPlaceCategoryMatMenu) < 0) {
            this._customDefaultPlaceCategoryMatMenus.push({
                trigger: customDefaultPlaceCategoryMatMenu,
                level,
            });
        }
    }

    public static get customDefaultPlaceCategoryMatMenus() {
        return this._customDefaultPlaceCategoryMatMenus;
    }

    public static clearCustomDefaultPlaceCategoryMatMenus() {
        this._customDefaultPlaceCategoryMatMenus = [];
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/stores/visitor.calendar.store.ts